import { render, staticRenderFns } from "./userComment.vue?vue&type=template&id=bd17e730&lang=pug"
import script from "./userComment.vue?vue&type=script&lang=js"
export * from "./userComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports